<script setup lang="ts">
import { CellState } from '../index'

withDefaults(
  defineProps<{
    label?: string | number
    state?: CellState
    today?: boolean
    outside?: boolean
  }>(),
  {
    label: '',
    state: CellState.Default,
  },
)
</script>

<template lang="pug">
button.calendar-day.calendar-cell.typ-14-20-500.flex-center-center.s-40(
  type="button"
  :class="{ [state]: state !== CellState.Default && state !== CellState.Disabled, today: today && state === CellState.Default, outside: outside && state === CellState.Default }"
  :disabled="state === CellState.Disabled"
  :aria-pressed="state === CellState.Selected || state === CellState.Start || state === CellState.Mid || state === CellState.End"
) {{ label }}
</template>

<style scoped src="../calendar.css"></style>
